import { apiJson } from '../api/apiClient';


const checkTenantStatus = async (tenant) => {
    const res = await apiJson(tenant, '/tenant-status');
    const status = res?.data?.status || res?.status || 'active';
    return {
        status,
        isSuspended: status === 'suspended',
    };
};

export default { checkTenantStatus };